import React from 'react'
import {Modal, Row} from 'antd'
import DriverForm from '../../../../components/Project/Resources/Drivers/DriverForm'
import FooterButtons from '../../../../elements/Buttons/FooterButtons'

function DriverModal(props) {
  const {
    visible,
    modalType,
    submitting,
    submit,
    update,
    formRef,
    onCancel,
    removing,
    remove,
  } = props
  return (
    <Modal
      visible={visible}
      title={'Driver'}
      onCancel={onCancel}
      destroyOnClose={true}
      footer={
        <FooterButtons
          remove={remove}
          removing={removing}
          submit={submit}
          update={update}
          submitting={submitting}
          title={'Department'}
          isNew={modalType === 'new'}
          isEdit={modalType !== 'new'}
        />
      }
      width={'75%'}>
      <Row>
        <DriverForm ref={formRef} {...props} />
      </Row>
    </Modal>
  )
}

DriverModal.propTypes = {}
DriverModal.defaultProps = {}

export default DriverModal
